<template>
    <v-container grid-list-xl id="app">
      <image-input v-model="avatar">
        <div slot="activator">
          <v-avatar size="150px" v-ripple v-if="!avatar" class="grey lighten-3 mb-3">
            <div>
            <div class="uploadText">Profilbild <br> hochladen</div>
             <div><v-icon class="uploadIcon">mdi-upload</v-icon></div>
            </div>
          </v-avatar>
          <v-avatar size="150px" v-ripple v-else class="mb-3">
            <img :src="avatar.imageURL" alt="avatar">
          </v-avatar>
        </div>
      </image-input>
      <v-slide-x-transition>
        <!--div v-if="avatar && saved == false">
          <v-btn class="primary" @click="uploadImage" :loading="saving">speichern</v-btn>
        </div-->
      </v-slide-x-transition>
      <v-progress-linear v-if="saving"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
    </v-container>
</template>

<script>
import ImageInput from '../components/ImageInput'
import {uploadI} from '../api';
export default {
  name: 'ImageUploaderComplete',
  data () {
    return {
      avatar: null,
      saving: false,
      saved: false
    }
  },
  props: {
    // Use "value" to enable using v-model
      value: String,
    },
  components: {
    ImageInput: ImageInput
  },
  watch:{
    avatar: {
      handler: function() {
        this.uploadImage()
      },
      deep: true
    }
  },
  methods: {
    uploadImage() {
      this.saving = true
      console.log(this.avatar.imageFile)
      uploadI(this.avatar.imageFile).then(value=>{
        console.log(value)
        this.$emit('input', value)
      })
      setTimeout(() => this.savedAvatar(), 1000)
    },
    savedAvatar() {
      this.saving = false
      this.saved = true
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
};





.uploadText{
  margin: 12px;
};

.uploadIcon{

text-color: green;
}
</style>